module.exports = __webpack_public_path__ + "img/pro_five_11.0053873b.jpg";